<template>
  <el-container class="page_container">
    <el-header class="diy-header">
      <h1 class="diy-header-h1">
        教务在线管理系统
        <span class="diy-header-x"></span>
      </h1>
      <div style="display: flex; align-items: center; gap: 12px; margin-right: 16px;">
        <span style="color: #fff; font-size: 14px; font-weight: 500;">{{realname}}</span>
        <el-button round style="background: transparent; border: 1px solid #fff; color: #fff;"
                   @click="openChangePasswordDialog">
          修改密码
        </el-button>

        <el-button type="primary" round @click="handleLogout">
          退出
        </el-button>
      </div>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <el-menu
          background-color="#1F1F1F"
          text-color="#fff"
          active-text-color="#40beff"
          unique-opened
          router
          :default-active="$route.path"
        >
        <template  v-for="item in menuslist">
          <el-menu-item v-if="item.path != ''" :key="item.id" :index="'/'+item.path">
            <template slot="title">
              <i :class="iconobj[item.id]"></i>
              <span>{{item.authName}}</span>
            </template>
          </el-menu-item>
          <el-submenu v-if="item.path == ''" :index="item.id+''" :key="item.id">
            <template slot="title">
              <i :class="iconobj[item.id]"></i>
              <span>{{item.authName}}</span>
            </template>
            <el-menu-item
              :index="'/'+subitem.path"
              v-for="subitem in item.children"
              :key="subitem.id"
            >
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span>{{subitem.authName}}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </template>
        </el-menu>
      </el-aside>
      <!-- 内容 -->
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-dialog title="修改密码" :visible.sync="modifyPasswordVisible" :close-on-click-modal="false">
        <!-- 绑定rules和ref -->
        <el-form
          :model="modifyPasswordForm"
          :rules="passwordRules"
          ref="passwordFormRef"
        >
          <!-- 原密码 -->
          <el-form-item label="原密码" prop="oldPassword">
            <el-input
              type="password"
              v-model="modifyPasswordForm.oldPassword"
              show-password
            />
          </el-form-item>

          <!-- 新密码 -->
          <el-form-item label="新密码" prop="password">
            <el-input
              type="password"
              v-model="modifyPasswordForm.password"
              show-password
            />
            <div class="tip">需8位以上且含字母+数字</div>
          </el-form-item>

          <!-- 确认密码 -->
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              type="password"
              v-model="modifyPasswordForm.confirmPassword"
              show-password
            />
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer-right">
            <el-button type="primary" @click="validatePasswordForm">提交</el-button>
            <el-button type="info" @click="closeModifyPasswordDialog">关闭</el-button>
          </div>
        </template>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    const validateNewPassword = (rule, value, callback) => {
      // 新旧密码相同时报错
      if (value === this.modifyPasswordForm.oldPassword) {
        callback(new Error('新密码不能与原密码相同'));
      } else {
        callback();
      }
    };

    // 自定义验证函数：检查两次输入是否一致
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.modifyPasswordForm.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };
    return {
      type:null,
      hoverExit: false,
      realname: '',
      modifyPasswordForm: [],
      modifyPasswordVisible: false,
      //左侧菜单数据
      menuslist: [
        {
          id: "101",
          authName: "在读学员",
          type:2,
          path: "studentList",
          children: [
          { id: "01", authName: "学员管理", path: "studentList"},
          ]
        }
      ],
      //图标数据
      iconobj: {
        "101": "iconfont icon-shangpin",
        "102": "iconfont icon-danju",
        "103": "iconfont icon-tijikongjian",
        "104": "iconfont icon-users",
        "105": "iconfont icon-baobiao",
        "106": "iconfont icon-danju",
        "107": "iconfont icon-danju",
        "108": "iconfont icon-danju",
        "109": "iconfont icon-baobiao",
        "110": "iconfont icon-users",
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          // 密码强度规则：8位+字母数字组合[3](@ref)
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/,
            message: '需8位以上且含字母+数字',
            trigger: 'blur'
          },
          // 新旧密码一致性检查
          { validator: validateNewPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          // 两次输入一致性检查
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    };
  },
  // 渲染前获取数据
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const { data: res } = await this.$http.get("/ea/sys/user/getUserPostionByToken");
      if(res.code == 200){
        const postion = res.result.postion;
        this.realname = res.result.realname;
        if(postion == 8){
          this.menuslist = [
            {
              id: "101",
              authName: "在读学员",
              type:2,
              path: "studentList",
              children: [
                { id: "01", authName: "学员管理", path: "studentList"},
              ]
            },
            {
              id: "104",
              authName: "学管点名",
              type:4,
              path: "callList",
              children: [{ id: "01", authName: "点名管理", path: "callList" }]
            },
            {
              id: "109",
              authName: "上课记录",
              type:9,
              path: "classRecord",
              children: [{ id: "01", authName: "上课记录", path: "classRecord" }]
            },
            {
              id: "103",
              authName: "班级管理",
              type:3,
              path: '',
              children: [
                { id: "01", authName: "班课班级", path: "classList" },
                { id: "02", authName: "1对1班级", path: "oneByOneClassList" }
              ]
            },
            {
              id: "106",
              authName: "课程管理",
              type:6,
              path: "courseList",
              children: [{ id: "01", authName: "课程管理", path: "courseList" }]
            },
            {
              id: "107",
              authName: "套餐管理",
              type:7,
              path: "setMealList",
              children: [{ id: "01", authName: "套餐管理", path: "setMealList" }]
            },
            {
              id: "105",
              authName: "员工管理",
              type:5,
              path: "staffList",
              children: [{ id: "01", authName: "员工管理", path: "staffList" }]
            },
            {
              id: "110",
              authName: "校区管理",
              type:10,
              path: "storeList",
              children: [{ id: "01", authName: "校区管理", path: "storeList" }]
            },
            {
              id: "108",
              authName: "财务中心",
              type:8,
              path: '',
              children: [{ id: "01", authName: "工资管理", path: "salaryList" }]
            },
          ];
        }else if(postion == 0){
            this.menuslist = [
              {
                id: "101",
                authName: "在读学员",
                type:2,
                path: "studentList",
                children: [
                  { id: "01", authName: "学员管理", path: "studentList"},
                ]
              },
              {
                id: "104",
                authName: "学管点名",
                type:4,
                path: "callList",
                children: [{ id: "01", authName: "点名管理", path: "callList" }]
              },
              {
                id: "109",
                authName: "上课记录",
                type:9,
                path: "classRecord",
                children: [{ id: "01", authName: "上课记录", path: "classRecord" }]
              },
              {
                id: "103",
                authName: "班级管理",
                type:3,
                path: '',
                children: [
                  { id: "01", authName: "班课班级", path: "classList" },
                  { id: "02", authName: "1对1班级", path: "oneByOneClassList" }
                ]
              },
              {
                id: "106",
                authName: "课程管理",
                type:6,
                path: "courseList",
                children: [{ id: "01", authName: "课程管理", path: "courseList" }]
              },
              {
                id: "107",
                authName: "套餐管理",
                type:7,
                path: "setMealList",
                children: [{ id: "01", authName: "套餐管理", path: "setMealList" }]
              },
              {
                id: "105",
                authName: "员工管理",
                type:5,
                path: "staffList",
                children: [{ id: "01", authName: "员工管理", path: "staffList" }]
              },
              {
                id: "108",
                authName: "财务中心",
                type:8,
                path: '',
                children: [{ id: "01", authName: "工资管理", path: "salaryList" }]
              },
            ];
        }else if(postion == 1){
            this.menuslist = [
              {
                id: "101",
                authName: "在读学员",
                type:2,
                path: "studentList",
                children: [
                  { id: "01", authName: "学员管理", path: "studentList"},
                ]
              },
              {
                id: "104",
                authName: "学管点名",
                type:4,
                path: "callList",
                children: [{ id: "01", authName: "点名管理", path: "callList" }]
              },
              {
                id: "109",
                authName: "上课记录",
                type:9,
                path: "classRecord",
                children: [{ id: "01", authName: "上课记录", path: "classRecord" }]
              },
              {
                id: "103",
                authName: "班级管理",
                type:3,
                path: '',
                children: [
                  { id: "01", authName: "班课班级", path: "classList" },
                  { id: "02", authName: "1对1班级", path: "oneByOneClassList" }
                ]
              },
              {
                id: "106",
                authName: "课程管理",
                type:6,
                path: "courseList",
                children: [{ id: "01", authName: "课程管理", path: "courseList" }]
              },
              {
                id: "107",
                authName: "套餐管理",
                type:7,
                path: "setMealList",
                children: [{ id: "01", authName: "套餐管理", path: "setMealList" }]
              },
            ];
        }
      }else {
        this.$message({
          showClose: true,
          message: res.message,
          type:'error'
        });
      }
    },
    async logout() {
      this.$router.push("/login");
    },
    openChangePasswordDialog() {
      this.modifyPasswordVisible = true
    },
    // 退出登录
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '退出确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里写你原来的退出逻辑：清除token、跳转登录等
        // example:
        // localStorage.removeItem('token')
        this.$router.push('/login')
        this.$message.success('已成功退出')
      }).catch(() => {
        this.$message.info('已取消退出')
      })
    },
    validatePasswordForm() {
      this.$refs.passwordFormRef.validate(valid => {
        if (valid) {
          // 验证通过，执行密码修改
          this.submitPasswordChange();
        } else {
          // 验证失败时自动显示红色错误提示
          this.$message.error('请检查表单错误');
        }
      });
    },
    async submitPasswordChange() {
      let form = {
        'oldPassword': this.modifyPasswordForm.oldPassword,
        'password': this.modifyPasswordForm.password,
      }
      const { data: res } = await this.$http.post("/ea/sys/user/modifyCurUserPassword", form);
      if(res.code == 200){
        this.modifyPasswordVisible = false;
        this.$message.success(res.message);
      }else{
        this.$message.error(res.message);
      }

    },
    closeModifyPasswordDialog() {
      this.modifyPasswordVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.page_container {
  height: 100%;
}
.el-header {
  background: #121212;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
}
.el-aside {
  background: #1F1F1F;

  .el-menu {
    border-right: none;
  }
}
.el-main {
  background: #F5F5F7;
}
.iconfont {
  margin-right: 5px;
}
.el-form-item.is-error .el-input__inner {
  border-color: #ff4d4f;
}
.tip {
  color: #999;
  font-size: 12px;
  margin-top: 4px;
}
.dialog-footer-right {
  display: flex;
  justify-content: flex-end; /* 按钮靠右 */
  gap: 12px; /* 按钮间距 */
}

/* 若需穿透 scoped */
::v-deep .dialog-footer-right {
  justify-content: flex-end;
}
  .diy-header{
    background: #121212;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-bottom: 1px solid #1F1F1F;
  }
  .diy-header-h1{
    color: #E0E0E0;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0.5px;
    margin: 0;
    position: relative;
    padding-bottom: 8px;
  }
  .diy-header-x{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, #64B5F6, transparent);
  }
</style>
<style scoped>
  /* 增大关闭按钮 */
  ::v-deep .el-dialog__headerbtn {
    font-size: 24px !important; /* 原始大小14px */
    top: 20px !important;       /* 微调位置避免遮挡 */
    right: 20px !important;
  }

  /* 调整图标位置 */
  ::v-deep .el-dialog__close {
    font-weight: bold;
  }
</style>
